/*
 * @Author: yinbing.liu
 * @Date: 2023-09-19 15:01:14
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-06-26 16:25:20
 * @FilePath: /fushigi/src/router/index.ts
 * @Description:  路由管理
 */
import {
  createRouter,
  createWebHistory,
  // RouteLocationNormalized,
  // RouteLocationNormalizedLoaded,
} from 'vue-router'
import { routes } from './modules/basic'

const router = createRouter({
  history: createWebHistory(),
  routes,
  // scrollBehavior(to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else if (to.hash) {
  //     return {
  //       el: to.hash,
  //       behavior: 'smooth',
  //     }
  //   } else {
  //     return { top: 0 }
  //   }
  // },
})

export default router
